// eslint-disable-next-line import/prefer-default-export
export const ZION_CMS_SITES = [
  'cabo-verde',
  'danmark',
  'deutschland',
  'espana',
  'europe',
  'italia',
  'norge',
  'portugal',
  'stories',
  'suomi',
  'sverige',
  'united-kingdom',
]
